import React from "react"
import { Stack, Typography } from "@mui/material"

export const GenericIconLabel = ({ icon, label, color, typographyProps, ...others }) => {
  return (
    <Stack direction={'row'} alignItems={'center'} gap={0.5} color={color} {...others}>
      {icon}
      <Typography {...typographyProps}>{label}</Typography>
    </Stack>
  )
};